import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getCompany = () => localStorage.getItem("company") || "sio";
export const setCompany = (id) => { localStorage.setItem("company", id); sessionStorage.setItem("entered", "1"); window.location.assign("/"); };
export const withCompany = (url) => `${url}${url.includes("?") ? "&" : "?"}company=${getCompany()}`;

const api = axios.create({ baseURL: API, timeout: 60000 });
api.interceptors.request.use((cfg) => { if (!cfg.headers["X-Company-Id"]) cfg.headers["X-Company-Id"] = getCompany(); return cfg; });

export default api;
